<template>
  <v-app class="app">
    <Banner />
    <Menu />
    <router-view></router-view>
    <Footer />
  </v-app>
</template>

<script>
import Menu from "./components/menu";
import Banner from "./components/banner";
import Footer from "./components/Footer";

export default {
  components: {
    Menu,
    Banner,
    Footer,
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  background: radial-gradient(
    circle,
    rgba(174, 238, 216, 0.075) 0%,
    rgba(168, 233, 148, 0.11) 100%
  ) !important;
}
a {
  text-decoration: none;
  margin: auto;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
a.router-link-exact-active {
  background: green;
  display: inline-block;
  width: fit-content;
  margin-top: -2px;
}

</style>
